import { colors } from "@itandi/itandi-bb-ui";
import type { Deal } from "./Deal";
import { ESTIMATION_BY } from "./Deal";

export type DealEstimationHeader = {
	confirmedTotalAmountWithTax: number;
	count: number;
	createdBy: string;
	id: number;
	note: string | null;
	noteModified: boolean;
	processedAt: string | null;
	requestedAt: string;
	staffName: string | null;
	status: DealEstimationHeaderStatus;
	totalAmountWithTax: number;
	vendorUserName: string | null;
};

type DealEstimationHeaderStatus =
	| "draft"
	| "request"
	| "cancel"
	| "accept"
	| "reject"
	| "accepted_by_system"
	| "rejected_by_system";

type ValidDealEstimationHeaderStatus = Exclude<
	DealEstimationHeaderStatus,
	"draft" | "accepted_by_system"
>;

// 見積り作成の責任がどちらの会社にあるかを判定する関数
// client == 管理会社, vendor == 施工会社
export const estimationRequestSide = (
	deal: Deal,
	companyType: "client" | "vendor"
): boolean => {
	if (companyType === "client") {
		return deal.estimationBy === ESTIMATION_BY.COMPANY;
	}
	return deal.estimationBy === ESTIMATION_BY.VENDOR;
};

export const statusLabel = (
	status: ValidDealEstimationHeaderStatus
): string => {
	switch (status) {
		case "request":
			return "申請中";
		case "cancel":
			return "取り下げ";
		case "accept":
			return "承認";
		case "reject":
		case "rejected_by_system":
			return "棄却";
		default:
			return "";
	}
};

export const statusBackgroundColors = (
	status: ValidDealEstimationHeaderStatus
): string => {
	switch (status) {
		case "request":
			return colors["expressive-blue"];
		case "accept":
			return colors["semantic-positive"];
		case "cancel":
		case "reject":
		case "rejected_by_system":
			return colors["semantic-negative"];
		default:
			return "";
	}
};
